@if (items?.length) {
  <div ngbDropdown placement="bottom-left">
    <button ngbDropdownToggle [class.selected]="items | selectedItem" [class.error]="hasError">
      @if (placeholder) {
        <label class="zero-text p-xsmall-reg label" for="item">{{ placeholder }}</label>
      }
      <div class="selected-item-container">
        <div class="item" [class.with-label]="!!placeholder" name="item">
          @if (items | selectedItem; as selectedItem) {
            {{ selectedItem }}
          } @else {
            {{ 'design-system.select.choose' | transloco }}
          }
        </div>
      </div>
      <web-design-system-icon name="chevron-2" color="dimmed" />
    </button>
    <div ngbDropdownMenu>
      @for (item of items; track item.value; let isLast = $last) {
        <div class="suggestion" [class.last]="isLast" (click)="select(item)" ngbDropdownItem>{{ item.label }}</div>
      }
    </div>
    @if (error) {
      <div class="zero-text p-xsmall-reg course-red mt-1">{{ error }}</div>
    }
  </div>
}
